import { v4 as uuid } from 'uuid';
import { MAP_CONTEXTS } from '@Pages/Hopinto/constants';
import { goToAdvancedSearch } from '@Pages/Hopinto/actions';
import { getSearchProperties } from '@Services/Search/Search';
import ResultsRunner from '@Services/AlertResults/ResultsRunner';
import UserDatabases from '@Services/UserDatabases';
import NotifyDialogsService from '@Containers/Dialogs/NotifyDialogsService';
import { _resolveAuth, _goToQuickSearch } from './utils';

function showNoResults(request) {
  NotifyDialogsService.openModalWindow({
    title: 'No results',
    text: "Reaxys didn't find results for your query. Please consider reformulation and try again.",
    type: 'error',
    confirmText: 'OK',
    backdrop: 'static',
    timestamp: new Date().toGMTString(),
    crumb: request,
    trackingOptions: {
      component: 'Advanced search',
    },
  });
}

// eslint-disable-next-line import/prefer-default-export
export const resolveAdvancedQL = _resolveAuth(async (params) => {
  const { database, ui: uiDirectives, hitsPerPage, context, query } = params;
  try {
    const queryFactItem = {
      id: 'root',
      facts: [
        {
          id: 'ADVANCED.QL',
          exist: false,
          advancedItems: [
            {
              advancedExpression: decodeURIComponent(query),
            },
          ],
        },
      ],
    };
    const request = {
      queryFactItem,
      searchId: uuid(),
      requestId: uuid(),
      hitsPerPage: hitsPerPage ? Number(hitsPerPage) : null,
      context: MAP_CONTEXTS[context],
    };

    const properties = await getSearchProperties();
    const advancedQueryletFromProperties = properties.find(({ id }) => id === 'ADVANCED.QL');

    if (advancedQueryletFromProperties) {
      goToAdvancedSearch({
        importedQuery: request,
        autoSearch: 'hopInto',
        hitsPerPage,
        uiDirectives,
        database,
      });
    } else {
      const databases = database ? [UserDatabases.getDatabaseIdByPrefix(database)] : UserDatabases.getListWithIds();
      const resultsRunner = new ResultsRunner(
        {
          ...request,
          databases,
        },
        {
          onEmptyResults: () => {
            showNoResults(request);
            _goToQuickSearch();
          },
          onError: () => {
            _goToQuickSearch();
          },
        }
      );
      resultsRunner.run();
    }
  } catch (e) {
    Logger.error(e);
    _goToQuickSearch();
  }
});
